'use strict';

import 'nls!./alerts.json';
import 'nls!./booking.json';
import 'nls!./form_errors.json';
import 'nls!./membership.json';
import 'nls!./form_photo.json';
import 'nls!./booking_message.json';



// WEBPACK FOOTER //
// ./app/src/nls/index.js